module.exports = __webpack_public_path__ + "static/Setup-b1ee03f47e2c1663db673b7ffdaacc6a.png";